import { ChevronDown, Upload,ChevronUp,CircleX} from 'lucide-react';
import React, { useState, useEffect,useRef} from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { AuthData } from "../../auth/AuthWrapper"
import axios from 'axios';
import {FileCode, Trash2,FileText, LayoutGrid, ClipboardList, File, Settings,Menu,FileCheck, FileClock,CircleChevronRight,CircleChevronLeft,UserCheck,User,Pencil, Plus} from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { API_SERVER_URL } from "../../utils/config_ip_details";
import { getUsername,getInitials } from "../../utils/common_functions";
import { apiCall } from "../../utils/server_utils";
import { API_SUCCESS_RESPONSE_CODE,API_SUCCESS_RESPONSE_CREATED_CODE } from "../../utils/config_mapping";
import PageLoader from '../common/pageloader';
import * as ReactDOM from 'react-dom';
import $ from "jquery";
import {trackError} from "../../utils/error_tracker"
import { Toast } from '../common/toast';
import { useNavigate} from "react-router-dom";
import { MoreVertical, Eye, Download, Share2, Star, Trash } from "lucide-react";
import clsx from "clsx";
import Select from 'react-select';


const data = [
  { name: 'Jan', documents: 4, techSpecs: 3 },
  { name: 'Feb', documents: 7, techSpecs: 5 },
  { name: 'Mar', documents: 9, techSpecs: 7 },
  { name: 'Apr', documents: 12, techSpecs: 9 },
  { name: 'May', documents: 15, techSpecs: 11 },
  { name: 'Jun', documents: 18, techSpecs: 14 },
];


const initialRequirements = [
    {
      id: 'REQ-001',
      text: 'The system shall support automated scaling of compute resources based on load.',
      section: 'Performance',
    },
    {
      id: 'REQ-002',
      text: 'All data at rest must be encrypted using AES-256 encryption.',
      section: 'Security',
    },
    {
      id: 'REQ-003',
      text: 'The system must maintain 99.99% uptime for availability.',
      section: 'Availability',
    },
  ];


  // const filters = ["All Documents", "Requirements", "Best Practices", "Templates", "Tech Specs", "Starred"];

  const filters = ["All Requirements",  "Starred"];

  const innerfilters = ["Technical",  "Service Role/Security"];


const documents = [
  {
    id: 1,
    title: "Infrastructure Requirements v1.2",
    date: "2023-10-15",
    size: "2.4 MB",
    author: "John Smith",
    tags: ["Requirements", "AWS", "Cloud", "Security"],
    type: "Active",
    starred: true,
    iconColor: "text-purple-500",
  },
  {
    id: 2,
    title: "GxP Compliance Guidelines",
    date: "2023-09-05",
    size: "1.7 MB",
    author: "Maria Rodriguez",
    tags: ["Best Practices", "GxP", "Validation", "Compliance"],
    type: "Active",
    starred: false,
    iconColor: "text-green-500",
  },
  {
    id: 3,
    title: "Technical Specification Template",
    date: "2023-08-22",
    size: "756 KB",
    author: "David Chen",
    tags: ["Template", "Template", "Specification"],
    type: "Active",
    starred: true,
    iconColor: "text-yellow-500",
  },
];


  // 🧩 Reusable NavItem component with hover tooltip
const NavItem = ({ to, icon, label, isSidebarOpen }) => (
  <NavLink
    to={to}
    className={({ isActive }) =>
      `group relative flex items-center p-2 rounded hover:bg-gray-700 transition-all duration-200 ${
        isSidebarOpen ? "justify-start" : "justify-center"
      } ${isActive ? "bg-white text-black font-medium" : "text-white"}`
    }
  >
    {icon}
    {isSidebarOpen ? (
      <span className="ml-2">{label}</span>
    ) : (
      <span className="absolute left-full ml-2 whitespace-nowrap bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-50 shadow-lg">
        {label}
      </span>
    )}
  </NavLink>
);



  
export const Requirements = ({selectedDocprops,closeRequirement,createSpec,selectedDocIndexprops

}) => {
  //const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
      // Initialize from localStorage, default to false
      const saved = localStorage.getItem('isSidebarOpen');
      return saved === 'true';
    });
  
    // Update localStorage whenever isSidebarOpen changes
    useEffect(() => {
      localStorage.setItem('isSidebarOpen', isSidebarOpen);
    }, [isSidebarOpen]);
    
  const { user, isLoggedIn, logout } = AuthData();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null); // API data for documents
  const [showUpload, setShowUpload] = useState(false);
  const navigate = useNavigate();
  const [activeFilter, setActiveFilter] = useState("All Requirements");
  const [activeInnerFilter, setInnerActiveFilter] = useState("Technical");
  
  const [openDropdown, setOpenDropdown] = useState(null);
  const dropdownRef = useRef(null);

    useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [dropdownRef]);

  
  const fetchWidget = async () => {
      setLoading(true); // Stop loading spinner
    try {
      const result = await apiCall("GET", `${API_SERVER_URL}requirements/`);
      if (result.code === API_SUCCESS_RESPONSE_CODE) {
        setData(result.data);
        setLoading(false);  
      }
    } catch (error) {
      setLoading(false);  
      console.error("Error fetching contracts", error);
    }
  };

  useEffect(() => {
        // Fetch data from the API
        fetchWidget();
      }, []);
      

  const documents = [
    {
      id: 1,
      name: "Document A",
      requirementsCount: 5,
      techSpec: "Tech Spec A",
    },
    {
      id: 2,
      name: "Document B",
      requirementsCount: 3,
      techSpec: null,
    }
  ];

  const fileInputRef = useRef(null);

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event) => {
    const files = event.target.files;
    if (files.length > 0) {
      // console.log('Selected files:', files);
      // handle the uploaded files here
    }
  };

  const [expandedDocId, setExpandedDocId] = useState(null);
  const [selectedDocIndex, setSelectedDocIndex] = useState(null);

  const toggleAccordion = (docId) => {
    setExpandedDocId(prev => (prev === docId ? null : docId));
    };
    const toggleUpload = () => {
        setShowUpload(!showUpload);
        setFiles([])
      };

      const handleViewRequirements = (index) => {
        $("#list_view,#btn_uplod").addClass("d-none")
        setSelectedDocIndex(index);
        setSelectedTypes([])
        setSearchText("")
        setInnerActiveFilter("Technical")
      };

      const closeDetailDocumentView = (index) => {
        $("#list_view,#btn_uplod").removeClass("d-none")
        setSelectedDocIndex(null);
      };


  const [requirements, setRequirements] = useState(initialRequirements);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingRequirement, setEditingRequirement] = useState(null);

  const handleOpenAdd = () => {
    setEditingRequirement(null);
    setModalOpen(true);
  };

  const handleEdit = (req) => {
    setEditingRequirement(req);
    setModalOpen(true);
  };

  const handleSave =  async (req) => {
    if (editingRequirement) {
      // Edit
      setRequirements((prev) =>
        prev.map((r) => (r.id === editingRequirement.id ? req : r))
      );
    } else {

      let postdata =  {
        "document_id": selectedDoc.document_id,
        "requirement_id": req.id,
        "description": req.text,
        "requirementType": req.section
      }

      let apiUrl = API_SERVER_URL+ 'requirements/'
          let method = "POST"
          try {
              const result = await apiCall(method,apiUrl,postdata);
              if(result!==undefined){
              if (result.code === API_SUCCESS_RESPONSE_CREATED_CODE) {
                fetchWidget();
              } else {
                trackError("The API response is invalid:<br/>URL:"+apiUrl+"<br/>Method:"+method+"<br>", JSON.stringify(result))
              }
              }
          } catch (error) {
            console.error("Error refreshing token:", error);
          }

      // Add
      //alert(1111);
      //setRequirements((prev) => [...prev, req]);
    }
    setModalOpen(false);
  };

  //const selectedDoc = selectedDocIndex!==null ? data.requirements_types[selectedDocIndex] : ""

  // let selectedDoc = selectedDocIndex!==null ? data.requirements_types.filter(
  //   (doc) => doc.document_id === selectedDocIndexprops
  // ) : ""


  // data.requirements_types.filter(
  //     (doc) => doc.document_id === selectedDocIndexprops
  //   )

  
  let selectedDoc = data === null ?  selectedDocprops[0] :  data.requirements_types.filter(
    (doc) => doc.document_id === selectedDocIndexprops
  )[0]


  console.log("**************");
  console.log(selectedDoc);
  console.log("**************");

  //  return;



  const [searchText, setSearchText] = useState('');
  const [selectedTypes, setSelectedTypes] = useState([]);

  
  let requirementTypes;
  let  filteredRequirements;
  if(selectedDoc!=="" && selectedDoc.requirements!==undefined){
   // alert(selectedDoc.requirements)
   requirementTypes = [
    ...new Set(selectedDoc.requirements.map((req) => req.requirementType))
  ].map((type) => ({ value: type, label: type }));


  
  const lowerSearch = searchText.toLowerCase();
  
  filteredRequirements = selectedDoc.requirements.filter((req) => {
    const selectedValues = selectedTypes.map((opt) => opt.value);
    const matchesType = selectedValues.length > 0 ? selectedValues.includes(req.requirementType) : true;
    // const matchesSearch = req.description.toLowerCase().includes(searchText.toLowerCase()) ;
    const matchesSearch =
    req.requirementId?.toLowerCase().includes(lowerSearch) ||
    req.id?.toLowerCase().includes(lowerSearch) ||
    req.requirementType?.toLowerCase().includes(lowerSearch) ||
    req.description?.toLowerCase().includes(lowerSearch) ||
    req.comment?.toLowerCase().includes(lowerSearch);
    return matchesType && matchesSearch;
  });
}

//alert(selectedDoc)


  const [expandedRows, setExpandedRows] = useState([]);

  const [confirmDelete, setConfirmDelete] = useState({ show: false, requirement: null,document_id:""});


  


  const toggleRow = (id) => {
    setExpandedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const handleCreateTechSpec = (id,name) => {
    //closeRequirement()
    //navigate("/tech-spec/"+id+"/"+name)
    createSpec(id,name)
  };

  
const initialState = {
  document_type: null,
  documentFile: null,
}

  const [files, setFiles] = useState([]);


  const handleDrop = (event) => {
    event.preventDefault();
    const droppedFiles = Array.from(event.dataTransfer.files);
    if (droppedFiles[0]?.size > 20 * 1024 * 1024) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        documentFile: "File size must not exceed 20 MB.",
      }));
      return;
    }
    setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
    setFormData((prev) => ({ ...prev, documentFile: droppedFiles[0] }));
    setErrors((prevErrors) => ({ ...prevErrors, documentFile: "" }));
  };


  const handleFileSelect = (event) => {
  const selectedFiles = Array.from(event.target.files);
  const file = selectedFiles[0];
  if (file?.size > 20 * 1024 * 1024) {
    setErrors((prevErrors) => ({
      ...prevErrors,
      documentFile: "File size must not exceed 20 MB.",
    }));
    return;
  }
  setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
  setFormData((prev) => ({ ...prev, documentFile: file }));
  setErrors((prevErrors) => ({ ...prevErrors, documentFile: "" }));
};

const handleDragOver = (event) => {
  event.preventDefault();
};


const validateForm = () => {
  const newErrors = {};
  if (!formData.documentFile) newErrors.documentFile = "Document File is required.";
  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

const [formData, setFormData] = useState(initialState);
const [errors, setErrors] = useState({});
const [showToast, setShowToast] = useState(false);



const handleSubmit = (e) => {
    const logged_user_name = getUsername();
    e.preventDefault();
    if (!validateForm()) return;
    $(".page_pro_load").show();
    const timestamp = Date.now();  // Current timestamp in milliseconds
    const randomDigits = Math.floor(Math.random() * 1000); // Generate 3 random digits (0-999)
    const uniqueId = "doc_"+parseInt(`${timestamp}${randomDigits}`.substr(0, 12)); // Concatenate and ensure 12 digits
    const formDataapi = new FormData();
    formDataapi.append('file',formData.documentFile);
    //formDataapi.append('document_type',formData.document_type.value);
    formDataapi.append('document_type',"test");
    formDataapi.append("username",logged_user_name);
    saveDocument(formDataapi)
  };


  
      const handleDelete = async () => {
        let dataId = confirmDelete.document_id
        let req_id = confirmDelete.requirement.requirementId
        // const dataId = event.target.getAttribute('data-id');
        //if(dataId){
          let apiUrl = API_SERVER_URL+ 'requirements/delete/'+req_id+'/document/'+dataId+'/'
          let method = "POST"
          try {
              const result = await apiCall(method,apiUrl);
              if(result!==undefined){
              if (result.code === API_SUCCESS_RESPONSE_CODE) {
                setConfirmDelete({ show: false, requirement: null,document_id:"" })
                fetchWidget();
              } else {
                trackError("The API response is invalid:<br/>URL:"+apiUrl+"<br/>Method:"+method+"<br>", JSON.stringify(result))
              }
              }
          } catch (error) {
            console.error("Error refreshing token:", error);
          }
        
      };

  const saveDocument = async (data) => {

    $("#uploaderror").html(""); // Clear previous error
    let authToken = localStorage.getItem("jsondata");
    if (authToken) {
      const jsonData = JSON.parse(authToken);
      authToken = jsonData.accessToken || "";
    }
    $("#process-loader").removeClass("d-none"); // Show loader
    try {
      const response = await axios.post(API_SERVER_URL + "document/", data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + authToken,
        },
      });
      if(response.data.code === API_SUCCESS_RESPONSE_CREATED_CODE) {
        toggleUpload()
        setFiles([])
        setShowToast(true)
        $("#process-loader").addClass("d-none");
        setLoading(true); // Stop loading spinner
        setTimeout(() => {
        fetchWidget();
        }, 5000);
      } else {
        console.log("API Error Data:", response.data); // Debugging API response
        $("#process-loader").addClass("d-none");
        if (
          response.data.data &&
          response.data.data.error &&
          response.data.data.error.message
        ) {
          $("#uploaderror").html(response.data.data.error.message);
        } else {
          $("#uploaderror").html("An unexpected error occurred.");
        }
      }
    } catch (error) {
      console.error("Error uploading the file:", error);
      $("#process-loader").addClass("d-none");
      $("#uploaderror").html(
        `<div class="alert alert-danger" role="alert">
  `+ error.response?.data?.error.message || "An unexpected error occurred."+`
</div>`
      );
    }
  };

    return (
        <main className="flex-1 p-6 bg-gray-100 overflow-y-auto">

        {showToast && (
       <Toast
       message="Success"
       subMessage="Requriment Successfully Uploaded!"
       type="success"
       duration={5000}
     />
      )}

{showUpload && (
     <form onSubmit={handleSubmit}>
      <div className="mb-6 border border-blue-200 bg-blue-50/50 rounded-xl shadow" 
                            onDrop={handleDrop}
                            onDragOver={handleDragOver}
      
      >
        <div className="p-4 border-b">
          <h2 className="text-lg font-semibold">Upload New Requirement</h2>
          <p className="text-sm text-gray-600">
            Supported formats: PDF, DOCX, XLSX, TXT, MD, CSV
          </p>
        </div>
        <div className="p-4">
          <div
            className="border-2 border-dashed border-blue-300 rounded-md p-6 text-center cursor-pointer hover:bg-blue-100 transition"
            onClick={handleClick}
          >
            <div className="flex justify-center">
              <div className="p-3 rounded-full bg-blue-100 text-blue-800">
                <Upload size={24} />
              </div>
            </div>
            <p className="font-medium text-blue-600">Upload Requirement</p>
            <p className="text-sm text-gray-500">Drag and drop your requirement here</p>
            <p className="mt-2 text-xs text-gray-400">
              Accepted: .docx, .pdf, .xlsx, .txt, .md, .csv | Max Size: 20MB
            </p>
            <input
              ref={fileInputRef}
              type="file"
              id="fileInput"
              accept=".docx,.pdf,.xlsx,.txt,.md,.csv"
              className="hidden"
              onChange={handleFileSelect}
            />

               <ul style={{ marginTop: "20px",wordBreak:"break-all" }}>
                                {files.map((file, index) => (
                                <span>{file.name}<br/></span> 
                                ))}
                              </ul>
                            <div id="uploaderror"></div>


          </div>
          <br/>
          <div className="flex justify-end">
          {/* <button onClick={handleSubmit} type="submit" className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-600">
                    Save
               </button> */}

<div id="process-loader" className='d-none pt-[10px] pr-[11px]'><div class="flex items-center space-x-2 text-sm text-gray-600">
  <svg class="w-5 h-5 animate-spin text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4l5-5-5-5v4a10 10 0 00-10 10h4z"></path>
  </svg>
  <span>Uploading file...</span>
</div></div>



<button 
  onClick={toggleUpload}
  type="button"
  className={`px-4 py-2 rounded text-white transition-colors duration-200 bg-blue-600 hover:bg-blue-700`}
>
  Cancel
</button>
&nbsp;&nbsp;&nbsp;

<button 
  disabled={files.length === 0}
  onClick={handleSubmit}
  type="submit"
  className={`px-4 py-2 rounded text-white transition-colors duration-200 
    ${files.length === 0 
      ? 'bg-gray-400 cursor-not-allowed' 
      : 'bg-blue-600 hover:bg-blue-700'}`}

>
  Save
</button>

               </div>
        </div>
      </div>

    

      </form>
      )
}
          {/* Document Activity Chart */}
          {loading ? (
                           <PageLoader />
                      ) :
<div class="">
{/* <div className={selectedDocIndex === null ? "p-6 " : "p-6 d-none"} id="list_view"  >
      <div className="flex items-center justify-between mb-4">
        <div className="flex gap-2 flex-wrap">
          {filters.map((filter) => (
            <button
              key={filter}
              onClick={() => setActiveFilter(filter)}
              className={clsx(
                "px-4 py-1.5 rounded-full text-sm border",
                activeFilter === filter
                  ? "bg-blue-600 text-white"
                  : "bg-white hover:bg-gray-100 text-gray-700 border-gray-300"
              )}
            >
              {filter}
            </button>
          ))}
        </div>
        <div className="flex gap-2">
          <input
            type="text"
            placeholder="Search ..."
            className="border border-gray-300 rounded px-3 py-1.5 text-sm"
          />
        </div>
      </div>
      <div className="space-y-4">
      </div>
    </div> */}

{/* 
<div class="bg-white rounded-lg shadow p-4 lg:col-span-1">
      <div class="text-center py-8 text-gray-500">
        <svg class="h-12 w-12 mx-auto mb-2 text-gray-300" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
          <path d="M3 3h18v18H3V3z" />
        </svg>
        <p>No requirement documents found</p>
      </div>
</div> */}
 

     {selectedDoc && (
        <>
         <div className="flex items-center justify-between mb-4">
                <div className="flex gap-2 flex-wrap">
                  {innerfilters.map((filter) => (
                    <button
                      key={filter}
                      onClick={() => setInnerActiveFilter(filter)}
                      className={clsx(
                        "d-none px-4 py-1.5 rounded-full text-sm border",
                        activeInnerFilter === filter
                          ? "bg-blue-600 text-white"
                          : "bg-white hover:bg-gray-100 text-gray-700 border-gray-300"
                      )}
                    >
                      {filter}
                    </button>
                  ))}
                </div>
                <div className="flex gap-2 d-none">
                  <input
                    type="text"
                    placeholder="Search ..."
                    className="border border-gray-300 rounded px-3 py-1.5 text-sm"
                  />
                </div>
              </div>


     <div className="flex gap-4 mb-4">
        <input
          type="text"
          placeholder="Search ..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          className="border px-3 py-2 rounded w-1/2 text-sm"
        />
        <div className="w-1/2">
          <Select
              options={requirementTypes}
              value={selectedTypes}
              onChange={setSelectedTypes}
              isClearable
              isMulti
              placeholder="Filter by Section"
          />
        </div>
      </div>

        <div className="p-6 bg-white shadow rounded-lg lg:col-span-5">
          {/* <button
      onClick={() => closeRequirement()}
      className="absolute top-[80px] right-[5px] bg-white text-black px-2 py-2 rounded-full shadow hover:bg-gray-100 flex items-center justify-center"
      >
      <CircleX size={25} color='#000' />
    </button> */}

         <div className="flex justify-between items-center mb-4">
  <div>
    <h2 className="text-xl font-semibold">{selectedDoc.title}</h2>
    <p className="text-sm text-gray-500">
      {selectedDoc.requirements.length} requirements found in this document
    </p>
  </div>

  <div className="flex gap-2">
    <button
      onClick={() => handleCreateTechSpec(selectedDoc.document_id, selectedDoc.title)}
      className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 flex items-center gap-2"
    >
      <FileClock size={16} />
      Generate Specifications
    </button>

    <button
      onClick={handleOpenAdd}
      className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 flex items-center gap-2"
    >
      <Plus size={16} />
      Add Requirement
    </button>
  </div>
</div>


          <table className="w-full text-sm text-left">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-3 font-medium text-gray-600">ID</th>
                <th className="p-3 font-medium text-gray-600">Section</th>
                <th className="p-3 font-medium text-gray-600">Requirement</th>
                <th className="p-3 font-medium text-gray-600 text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {
              filteredRequirements.map((req,index) => (
              <React.Fragment key={req.id}>
                <tr className="border-b hover:bg-gray-50">
                  {/* <td className="p-3 cursor-pointer text-blue-600 hover:underline" onClick={() => toggleRow(index)}>
                    {req.id}
                  </td> */}
                  <td
                    className="p-3 cursor-pointer text-blue-600 hover:underline flex items-center gap-2"
                    onClick={() => toggleRow(index)}
                  >
                    {expandedRows.includes(index) ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                    {req.id}
                  </td>
                  <td className="p-3">{req.requirementType}</td>
                  <td className="p-3 truncate max-w-xs">{req.description}</td>
                  <td className="p-3 text-center">
                    <button
                      // onClick={() => confirmAndDelete(req)}
                      onClick={() => setConfirmDelete({ show: true, requirement: req,document_id:selectedDoc.document_id})}
                      // className="text-red-600 hover:text-red-800"
                    >
                      <Trash2 size={16} />
                    </button>
                  </td>
                </tr>
                {expandedRows.includes(index) && (
                  <tr className="bg-gray-50">
                    <td colSpan={4} className="p-3 text-gray-800">
                      <strong>Requirement:</strong> {req.description}
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))
          }
          {
            filteredRequirements.length===0 ? 
            <tr><td colSpan={4} className='text-center'>No Record Found</td></tr> : ""
          }
            </tbody>
          </table>


          {confirmDelete.show && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-sm">
      <h3 className="text-lg font-semibold mb-4">Delete Requirement</h3>
      <p className="text-sm text-gray-700 mb-6">
        Are you sure you want to delete requirement ID <strong>{confirmDelete.requirement.id}</strong>?
      </p>
      <div className="flex justify-end gap-2">
        <button
          className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800"
          onClick={() => setConfirmDelete({ show: false, requirement: null,document_id:"" })}
        >
          Cancel
        </button>
        <button
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 text-sm"
          onClick={() => {
            //handleDelete(confirmDelete.requirement.id);
            handleDelete();
          }}
        >
          Delete
        </button>
      </div>
    </div>
  </div>
)}


      {modalOpen && (
        <RequirementModal
          onClose={() => setModalOpen(false)}
          onSave={handleSave}
          initialData={editingRequirement}

        />
      )}

        </div>
        </>
      )} 

          </div>
        }
        </main>
  );
};


function RequirementModal({ onClose, onSave, initialData }) {
    const [id, setId] = useState(initialData?.id || '');
    const [text, setText] = useState(initialData?.text || '');
    const [section, setSection] = useState(initialData?.section || '');
  
    const handleSubmit = (e) => {
      e.preventDefault();
      if (id && text && section) {
        //alert(id)
        //alert(text)
        //alert(section)
        onSave({ id, text, section });
      }
    };
  
    return (
      <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
          <h3 className="text-lg font-semibold mb-4">
            {initialData ? 'Edit Requirement' : 'Add New Requirement'}
          </h3>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium">Requirement ID</label>
              <input
                className="w-full border border-gray-300 rounded px-3 py-2 mt-1"
                value={id}
                onChange={(e) => setId(e.target.value)}
                placeholder="e.g., REQ-001"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium">Requirement Text</label>
              <textarea
                className="w-full border border-gray-300 rounded px-3 py-2 mt-1"
                value={text}
                onChange={(e) => setText(e.target.value)}
                rows={3}
                placeholder="Enter the requirement description..."
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium">Section</label>
              <input
                className="w-full border border-gray-300 rounded px-3 py-2 mt-1"
                value={section}
                onChange={(e) => setSection(e.target.value)}
                placeholder="e.g., Performance, Security, etc."
                required
              />
            </div>
            <div className="flex justify-end gap-2 mt-4">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 border rounded text-gray-600 hover:bg-gray-100"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Save Changes
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }